module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "readmore",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.openArticle($event)
      }
    }
  }, [_c('span', {
    staticClass: "readmore__external"
  }, [_c('a', {
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "readmore__tag"
  }, [_vm._v("Read more: ")]), _vm._v(" "), _c('span', {
    staticClass: "readmore__link"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d7e1e86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/custom/readmore.vue
// module id = 238
// module chunks = 1